import { render } from "./AdministrationPanel.vue?vue&type=template&id=35aa1f53&scoped=true"
import script from "./AdministrationPanel.vue?vue&type=script&lang=js"
export * from "./AdministrationPanel.vue?vue&type=script&lang=js"

import "./AdministrationPanel.vue?vue&type=style&index=0&id=35aa1f53&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aa1f53"]])

export default __exports__